/**
 * Socket.IO Client Service — Real-time connection to backend
 */
import { io } from 'socket.io-client';

class SocketService {
  constructor() {
    this.socket = null;
    this.listeners = new Map();
  }

  connect(token) {
    if (this.socket?.connected) return;

    // Connect to same origin (nginx proxies /socket.io/ → backend)
    this.socket = io(window.location.origin, {
      auth: { token },
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 2000,
      reconnectionDelayMax: 10000,
    });

    this.socket.on('connect', () => {
      console.debug('[Socket] Connected');
    });

    this.socket.on('disconnect', (reason) => {
      console.debug('[Socket] Disconnected:', reason);
    });

    this.socket.on('connect_error', (err) => {
      console.debug('[Socket] Connection error:', err.message);
    });

    // Re-attach any listeners that were registered before connect
    for (const [event, callbacks] of this.listeners) {
      for (const cb of callbacks) {
        this.socket.on(event, cb);
      }
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
    this.listeners.clear();
  }

  on(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, new Set());
    }
    this.listeners.get(event).add(callback);
    if (this.socket) {
      this.socket.on(event, callback);
    }
  }

  off(event, callback) {
    if (this.listeners.has(event)) {
      this.listeners.get(event).delete(callback);
    }
    if (this.socket) {
      this.socket.off(event, callback);
    }
  }

  get connected() {
    return !!this.socket?.connected;
  }
}

// Singleton
const socketService = new SocketService();
export default socketService;
